export interface Option<T extends string> {
	value: T;
	label: string;
}

export const createOptionsFrom = <T extends string>(obj: Record<T, string>): Option<T>[] => {
	return Object.entries(obj).map(([key, label]) => ({
		value: key as T,
		label: label as string
	}));
};
